/*
 * Assign-delivery.ts
 * Description: Includes the declaration
 * of the assign deliveries function
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Assigning a delivery person to an order
 *
 * @return {Object} Promise - submitted order
 * @param {Number} id - order id
 * @param {Number} userId - id of the delivery user
 * @param {String} slug - id of a restaurant
 * @param {String} status - status of the delivery
 */
export function assignDelivery(id: number, slug: string, userId: number, status: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/orders/' + id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                delivery_user_id: userId,
                status,
            },
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
